import { Text } from '@lmc/ui-kit/src/general'
import { Popover } from 'antd'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import TeamMemberAbsence from './TeamMemberAbsence'

type AbsencesPopoverProps = {
  children: ReactNode
  users?: any[]
}

const AbsencesPopover = ({ children, users }: AbsencesPopoverProps) => {
  const { t } = useTranslation()

  if (!users) return null

  return (
    <Popover
      placement="bottomRight"
      showArrow
      trigger="hover"
      arrow={{ pointAtCenter: true }}
      content={
        <Container>
          <LightText weight="medium" level={2}>
            {t('ABSENT')}
          </LightText>
          {users.map((user) => (
            <TeamMemberAbsence user={user} />
          ))}
        </Container>
      }
    >
      {children}
    </Popover>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 4px;
`
const LightText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

export default AbsencesPopover
